import { useState } from "react";
import type { FormEvent } from "react";

interface CreateFormModalProps {
  teamId: string;
  teamName?: string;
  onClose: () => void;
  onSubmit: (data: { teamId: string; title: string; description: string }) => void;
  isLoading?: boolean;
  error?: string | null;
}

export function CreateFormModal({ teamId, teamName, onClose, onSubmit, isLoading, error }: CreateFormModalProps): JSX.Element {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (title.trim()) {
      onSubmit({ teamId, title: title.trim(), description: description.trim() });
    }
  };

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        className="modal-content surface"
        style={{
          background: "var(--color-surface)",
          padding: "2rem",
          borderRadius: "12px",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ marginBottom: "0.5rem" }}>Create New Form</h2>
        {teamName && (
          <p style={{ color: "var(--color-text-muted)", marginBottom: "1.5rem" }}>
            Team: {teamName}
          </p>
        )}

        <form onSubmit={handleSubmit}>
          {error && (
            <div
              style={{
                padding: "0.75rem",
                marginBottom: "1.5rem",
                background: "var(--color-error-bg, #fee)",
                border: "1px solid var(--color-error, #f44)",
                borderRadius: "8px",
                color: "var(--color-error, #c00)",
              }}
            >
              {error}
            </div>
          )}

          <div style={{ marginBottom: "1.5rem" }}>
            <label
              htmlFor="form-title"
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: 500,
              }}
            >
              Form Title *
            </label>
            <input
              id="form-title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter form title"
              required
              autoFocus
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--color-border)",
                borderRadius: "8px",
                fontSize: "1rem",
                background: "var(--color-background)",
              }}
            />
          </div>

          <div style={{ marginBottom: "2rem" }}>
            <label
              htmlFor="form-description"
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: 500,
              }}
            >
              Description (optional)
            </label>
            <textarea
              id="form-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter form description"
              rows={3}
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid var(--color-border)",
                borderRadius: "8px",
                fontSize: "1rem",
                background: "var(--color-background)",
                resize: "vertical",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "0.75rem", justifyContent: "flex-end" }}>
            <button
              type="button"
              className="button ghost"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="button primary"
              disabled={!title.trim() || isLoading}
            >
              {isLoading ? "Creating..." : "Create Form"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
